module.exports = __webpack_public_path__ + "img/radio-hover.ccee4142.png";